import { render, staticRenderFns } from "./AdvertsPage.vue?vue&type=template&id=0e82136c&lang=pug&"
import script from "./AdvertsPage.vue?vue&type=script&lang=js&"
export * from "./AdvertsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports